module.exports = __webpack_public_path__ + "static/media/nba-team-maker.0cf275b7.png";